import { createStore, sample } from 'effector'
import { omit } from 'lodash'
import keyBy from 'lodash/keyBy'

import * as chat from '@/entities/chat'

import type * as api from '../api'
import * as connModel from './model.conn'
import * as userModel from './model.user'

export const $userMutes = createStore<Record<string, api.UserMute>>({})
export const $isUserMuted = chat.$userInfo.map((userInfo) => chat.isUserMuted(userInfo?.mute))

sample({
    clock: userModel.loginFx.doneData,
    fn: (response) => keyBy(response.user_mutes, (mute) => mute.user_id),
    target: $userMutes,
})

// -- Mute --

// update user registry with mute info
sample({
    clock: connModel.userMuted,
    source: $userMutes,
    fn: (mutes, mute) => ({ ...mutes, [mute.user_id]: mute }),
    target: $userMutes,
})

// update user mute info
// TODO: subscribe to $userMutes instead?
sample({
    clock: connModel.userMuted,
    source: chat.$userInfo,
    filter: (userInfo, mute) => userInfo?.user_id === mute.user_id,
    fn: (userInfo, mute): chat.UserInfo => ({
        ...userInfo!,
        mute: { expire_time: mute.expire_time },
    }),
    target: chat.$userInfo,
})

// -- Unmute --

// update user mute info
sample({
    clock: connModel.userUnmuted,
    source: chat.$userInfo,
    filter: (userInfo, mute) => userInfo?.user_id === mute.user_id,
    fn: (userInfo) => omit(userInfo, 'mute'),
    target: chat.$userInfo,
})

// remove user mute info from registry
sample({
    clock: connModel.userUnmuted,
    source: $userMutes,
    fn: (mutes, mute) => omit(mutes, mute.user_id),
    target: $userMutes,
})
